import { NewAddress } from '@/components/forms'
import { useRequireAuth } from '@/hooks/use-require-auth'
import { verifyUserInCart } from '@/lib'

export default function NewAddressPage() {
  useRequireAuth(verifyUserInCart)

  return <NewAddress redirectTo="/cart/checkout/service" text="Em qual endereço você deseja receber seu pedido?" />
}
